import { createSlice } from "@reduxjs/toolkit";
import { boolean } from "yup/lib/locale";

const slice = createSlice({
    name: "portalStyle",
    initialState: {
        Colors: [],
        Fonts: [],
        Footer_Background: "",
        Header_Background: "",
        Header_Logo: "",
        Header_Title: "",
        Invoices_Logo: "",
        Invoices_Payment_Logo: "",
        Notification_POPUP: "",
        Profile_Image: "",
        Service_Card_Background: "",
        Spinner: "",
        favicon: "",
        Show_Offers: false
    },
    reducers: {
        portalStyleAdded: (portalStyle, { payload }) => ({
            Colors: payload.Colors,
            Fonts: payload.Fonts,
            Footer_Background: payload.Footer_Background,
            Header_Background: payload?.Header_Background,
            Header_Logo: payload?.Header_Logo,
            Header_Title: payload?.Header_Title,
            Invoices_Logo: payload?.Invoices_Logo,
            Invoices_Payment_Logo: payload?.Invoices_Payment_Logo,
            Notification_POPUP: payload?.Notification_POPUP,
            Profile_Image: payload?.Profile_Image,
            Service_Card_Background: payload?.Service_Card_Background,
            Spinner: payload?.Spinner,
            favicon: payload?.favicon,
            Show_Offers: payload?.Show_Offers
        })
    },
});

export const { portalStyleAdded } = slice.actions;
export default slice.reducer;
